module.exports = __webpack_public_path__ + "img/32.de13b563.jpg";